import { SponsorAdArgsType } from "./type";
import React from "react";
import SponsorAdStorage from "./sponsorAdStorage";
import { AnalyticsActionNameEnum, AnalyticsEventNameEnum } from "../../enums/AnalyticsEnums";
import { getAnalyticsScreenType } from "./util";
import AnalyticsDatastoreType from "shared/enums/AnalyticsDatastoreType";

export default function useSponsorAdBrandingService({
  onSponsorAdDisplayChange,
  displayHeader = true,
  logAnalyticsEvent,
  ...props
}: SponsorAdArgsType) {
  const [showSponsorAd, setShowSponsorAd] = React.useState<boolean>(false);

  const toggleShowSponsorAd = React.useCallback(
    (status: boolean) => {
      setShowSponsorAd(status);
      onSponsorAdDisplayChange?.(status);
    },
    [onSponsorAdDisplayChange]
  );

  React.useEffect(() => {
    const adStatus = SponsorAdStorage.getSponsorAdStatus(props.uuid);
    toggleShowSponsorAd(!adStatus);
  }, [props.uuid, toggleShowSponsorAd]);

  const sponsorAdCloseHandler = React.useCallback(() => {
    props.adList.forEach(adObj => {
      logAnalyticsEvent?.(
        AnalyticsEventNameEnum.DIGITAL_ADS,
        {
          action: AnalyticsActionNameEnum.CLOSE,
          screenType: getAnalyticsScreenType(props.inventorySubType),
          contextEntityName: adObj.sponsorName,
          contextEntityId: adObj.sponsorUrl
        },
        AnalyticsDatastoreType.MIXPANEL_BUSINESS
      );
    });
    SponsorAdStorage.setSponsorAdStatus(props.uuid, true);
    toggleShowSponsorAd(false);
  }, [logAnalyticsEvent, props.uuid, toggleShowSponsorAd, props.adList, props.inventorySubType]);

  return {
    sponsorAdCloseHandler,
    showSponsorAd,
    displayHeader
  };
}
